module.exports = __webpack_public_path__ + "img/paisajesuccessfullregistrationdesktop.6b03a0ff.jpg";